import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { setLogoImageBase64Url } from "../../../store/slices/deckblattSlice";
import { useDispatch } from "react-redux";
import {
  useGetProfileLogoQuery,
  useUpdateProfileLogoMutation,
} from "../../../services/API/ProfileAPI";
import { toast } from "react-toastify";

function Preferences() {
  const { t } = useTranslation(["account"]);
  const dispatch = useDispatch();
  const { data: profileData, isLoading } = useGetProfileLogoQuery();
  const [updateProfileLogo] = useUpdateProfileLogoMutation();

  const [formState, setFormState] = useState({ logoBase64Url: "" });
  const [isConverting, setIsConverting] = useState(false);

  const handeleDeleteLogo = (e) => {
    setFormState({ logoBase64Url: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await updateProfileLogo({ logoBase64Url: formState.logoBase64Url })
      .then(async (result) => {
        if (result?.error?.status === 500) {
          toast.error(t("error.client.ServerError"));
          return;
        }

        if (result?.data === "OK") {
          dispatch(setLogoImageBase64Url(formState.logoBase64Url));
          toast.success(t("successLogo"));
          return;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleFileInputChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    // The base64 conversion is async; block saving until it finishes so the
    // PUT never sends the previous (or empty) logo value on a fast click.
    setIsConverting(true);
    getBase64(file)
      .then((result) => {
        file["base64"] = result;
        setFormState({ logoBase64Url: result });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsConverting(false);
      });
  };

  useEffect(() => {
    if (!isLoading) {
      if (profileData?.logoBase64Url !== formState.logoBase64Url)
        setFormState({ logoBase64Url: profileData?.logoBase64Url });
    }
  }, [isLoading]);
  return (
    <Card className="mb-4">
      <Card.Header> {t("preferencesHeader")}</Card.Header>
      <Card.Body>
        <Form>
          <Row>
            <Form.Group className="mt-3" controlId="formCompanyLogo">
              <Form.Label>{t("companyLogo")}</Form.Label>
              <div className="mt-3">
                {formState.logoBase64Url === "" && isLoading ? (
                  t("noImage")
                ) : (
                  <img src={formState?.logoBase64Url} style={{ width: "360px" }} alt="" />
                )}
              </div>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} className="mt-3">
              <Form.Control
                type={"file"}
                className={"file"}
                placeholder={""}
                accept={"image/jpeg, image/png"}
                onChange={handleFileInputChange}
              />
            </Form.Group>
            <Form.Group as={Col} sm={2} className="mt-3">
              <Button onClick={handeleDeleteLogo}>{t("delete")}</Button>
            </Form.Group>
          </Row>
          <Button
            as={Col}
            size={2}
            className="mt-3"
            variant="primary"
            type="submit"
            onClick={handleSubmit}
            disabled={isConverting}
          >
            {t("save")}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default Preferences;
